export const taptapPayments = [
  { code: 'BREX/ST', department: 'Cashier' },
  { code: 'NAB/ST', department: 'Cashier' },
  { code: 'WISELY/ST', department: 'Cashier' },
  { code: 'MAYA/ST', department: 'Cashier' },
  { code: 'MARIBANK/ST', department: 'Cashier' },
  { code: 'BANK_OF_AMERICA/ST', department: 'Cashier' },
  { code: 'BSP/ST', department: 'Cashier' },
  { code: 'SHIPMONEY/ST', department: 'Cashier' },
  { code: 'JCB/ST', department: 'Cashier' },
  { code: 'NAVY_FEDERAL_CREDIT_UNION/ST', department: 'Cashier' },
  { code: 'BANANA_REPUBLIC/ST', department: 'Cashier' },
  { code: 'CAPITALONE/ST', department: 'Cashier' },
  { code: 'RBC/ST', department: 'Cashier' },
  { code: 'HOME_CREDIT/ST', department: 'Cashier' },
  { code: 'UOB/ST', department: 'Cashier' },
  { code: 'POSB/ST', department: 'Cashier' },
  { code: 'THOMAS_COOK/ST', department: 'Cashier' },
  { code: 'LANDBANK/ST', department: 'Cashier' },
  { code: 'CB_CC_6M', department: 'Cashier' },
  { code: 'MARI_BANK/ST', department: 'Cashier' },
  { code: 'BOURSO/ST', department: 'Cashier' },
  { code: 'CHASE/ST', department: 'Cashier' },
  { code: 'AUB/ST', department: 'Cashier' },
  { code: 'GCASH/ST', department: 'Cashier' },
  { code: 'MAYA_BLACK/ST', department: 'Cashier' },
  { code: 'SALMON/ST', department: 'Cashier' },
  { code: 'GOTYME/ST', department: 'Cashier' },
  { code: '2C2P_IPP_3M', department: 'Cashier' },
  { code: 'BANK_OF_COMMERCE/ST', department: 'Cashier' },
  { code: 'ATOME/ST', department: 'Cashier' },
  { code: '2C2P_IPP_12M', department: 'Cashier' },
  { code: 'HSBC/ST', department: 'Cashier' },
  { code: 'CITI/ST', department: 'Cashier' },
  { code: 'MAYA_LANDERS/ST', department: 'Cashier' },
  { code: 'SECURITY_BANK/ST', department: 'Cashier' },
  { code: 'EW/ST', department: 'Cashier' },
  { code: 'UB_CHEQUE_DEPOSIT', department: 'Ecomm' },
  { code: 'BDO_CHEQUE_DEPOSIT', department: 'Ecomm' },
  { code: 'BPI_CHEQUE_DEPOSIT', department: 'Ecomm' },
  { code: '2307', department: 'Ecomm' },
  { code: 'PSBANK/ST', department: 'Cashier' },
  { code: 'PNB/ST', department: 'Cashier' },
  { code: 'CB/ST', department: 'Cashier' },
  { code: 'METROBANK/ST', department: 'Cashier' },
  { code: 'BDO/ST', department: 'Cashier' },
  { code: 'BPI/ST', department: 'Cashier' },
  { code: 'PSBANK_CC_12M', department: 'Cashier' },
  { code: 'PSBANK_CC_9M', department: 'Cashier' },
  { code: 'PSBANK_CC_6M', department: 'Cashier' },
  { code: 'PSBANK_CC_3M', department: 'Cashier' },
  { code: 'METROBANK_CC_12M', department: 'Cashier' },
  { code: 'METROBANK_CC_9M', department: 'Cashier' },
  { code: 'METROBANK_CC_6M', department: 'Cashier' },
  { code: 'METROBANK_CC_3M', department: 'Cashier' },
  { code: 'GCASH', department: 'Ecomm' },
  { code: 'CASH', department: 'Cashier' },
  { code: 'BDO', department: 'Ecomm' },
  { code: 'PAYMAYA', department: 'Ecomm' },
  { code: 'BILLEASE', department: 'Ecomm' },
  { code: 'PAYMONGO', department: 'Ecomm' },
  { code: 'BDO_CC_24M', department: 'Cashier' },
  { code: 'BDO_BT', department: 'Cashier' },
  { code: 'BPI_CC_12M', department: 'Cashier' },
  { code: 'BDO_CC_12M', department: 'Cashier' },
  { code: 'BPI_CC_3M', department: 'Cashier' },
  { code: 'CC_STRAIGHT', department: 'Cashier' },
  { code: 'EW_CC_3M', department: 'Cashier' },
  { code: 'BDO_CC_3M', department: 'Cashier' },
  { code: 'HSBC_CC_3M', department: 'Cashier' },
  { code: 'HOME_CREDIT', department: 'Cashier' },
  { code: 'BPI_BT', department: 'Ecomm' },
  { code: 'EW_CC_12M', department: 'Cashier' },
  { code: 'PAYMONGO_BILLEASE', department: 'Ecomm' },
  { code: 'PAYMONGO_CC', department: 'Ecomm' },
  { code: 'HSBC_CC_12M', department: 'Cashier' },
  { code: 'CB_CC_3M', department: 'Cashier' },
  { code: 'BDO_CC_6M', department: 'Cashier' },
  { code: 'PAYMONGO_GGIVES', department: 'Ecomm' },
  { code: 'EW_CC_6M', department: 'Cashier' },
  { code: 'KACHI POINTS', department: 'Ecomm' },
  { code: 'HSBC_CC_6M', department: 'Cashier' },
  { code: 'REFUND', department: 'Accounting' },
  { code: 'BPI_CC_6M', department: 'Cashier' },
  { code: 'UNIONBANK_BT', department: 'Cashier' },
  { code: 'PAYMONGO_GCASH', department: 'Ecomm' },
  { code: 'DEPOSIT_CHEQUE', department: 'Ecomm' },
  { code: 'PAYMONGO_MAYA', department: 'Ecomm' },
  { code: 'DEPOSIT_CASH', department: 'Ecomm' },
  { code: 'CB_CC_12M', department: 'Cashier' },
  { code: 'BDO_CC_9M', department: 'Cashier' },
  { code: 'PAYMONGO_SHOPEE', department: 'Ecomm' },
  { code: 'UNIONBANK_ST', department: 'Cashier' },
  { code: 'LANDBANK_BT', department: 'Cashier' },
  { code: 'RCBC_ST', department: 'Cashier' }
];

export const ECOMM_PAYMENT_TYPES = new Set(
  taptapPayments
    .filter((p) => p.department === 'Ecomm')
    .map((p) => p.code.toUpperCase())
);
